import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  outlinedButton: {
    borderColor: '#46A29F',
    borderRadius: 16,
    color: '#FFF',
    padding: '8px 32px',
    '&.Mui-disabled': {
      borderColor: grey[500],
      color: grey[500],
    },
  },
});

const OutlinedButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  const { outlinedButton } = useStyles();
  return (
    <Button
      className={outlinedButton}
      color="inherit"
      variant="outlined"
      {...props}
    >
      {children}
    </Button>
  );
};

export default OutlinedButton;
